import type { SlackMessage } from '../systems/EventBus';

export const CFO_MESSAGES: readonly SlackMessage[] = [
  {
    id: 'cfo-write-off',
    author: 'cfo',
    body:
      "hey — just write off delta's $800, not worth chasing. been past 90 forever. tag it in the spreadsheet so it's clean for the close.",
    fictionalMinutes: 930,
  },
];
